import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import GoogleMapReact from 'google-map-react';
import Marker from './Marker';
import ResultMarker from './ResultMarker';
import classes from './MapLocation.module.scss';

const MapLocation = ({ center, defaultZoom, onMapApiLoaded, onSelectLocation, places, selectedLocation, styles, ...props }) => {
  const [options, setOptions] = useState({ center: {}, marker: {}, zoom: defaultZoom });

  const setState = (state = {}) => {
    setOptions((prevState) => {
      return {
        ...prevState,
        ...state
      };
    });
  };

  useEffect(() => {
    setState({
      center: {
        lat: selectedLocation?.lat ? selectedLocation.lat : center.lat,
        lng: selectedLocation?.lng ? selectedLocation.lng : center.lng
      },
      marker: { lat: selectedLocation?.lat, lng: selectedLocation?.lng, label: selectedLocation?.locationName }
    });
  }, [selectedLocation]);

  const onMarkerInteraction = (childKey, childProps, mouse) => {
    setState({ draggable: false, marker: { lat: mouse.lat, lng: mouse.lng } });
  };

  const onMarkerInteractionMouseUp = (childKey, childProps, mouse) => {
    setState({ draggable: true });
    onSelectLocation({ lat: mouse.lat, lng: mouse.lng });
  };

  const onChange = ({ center, zoom }) => {
    setState({
      center: center,
      zoom: zoom
    });
  };

  // TODO: hide other result names on click, prevent moving the middle marker
  const onClick = (value) => {
    // On mobile, tapping the zoom and full screen buttons trigger this onClick
    // this will prevent selecting a location when Google Map controls are tapped
    if (value.event?.target?.classList?.contains('gm-control-active')) return;
    onSelectLocation({ lat: value.lat, lng: value.lng });
  };

  return (
    <div className={classes.mapContainer} style={styles}>
      <GoogleMapReact
        center={options.center}
        zoom={options.zoom}
        draggable={options.draggable}
        onChange={onChange}
        onChildMouseDown={onMarkerInteraction}
        onChildMouseUp={onMarkerInteractionMouseUp}
        onChildMouseMove={onMarkerInteraction}
        onChildClick={() => {}}
        onClick={onClick}
        yesIWantToUseGoogleMapApiInternals
        onGoogleApiLoaded={onMapApiLoaded}
      >
        {options?.marker?.lat && options?.marker?.lng && <Marker text={options.marker.label} lat={options.marker.lat} lng={options.marker.lng} />}
        {places.map((place, index) => {
          if (!place.lat || !place.lng) return;

          return <ResultMarker text={place.text || ''} lat={place.lat} lng={place.lng} key={index} />;
        })}
      </GoogleMapReact>
    </div>
  );
};

MapLocation.propTypes = {
  className: PropTypes.oneOfType([PropTypes.array, PropTypes.string]),
  styles: PropTypes.object,
  defaultZoom: PropTypes.number,
  center: PropTypes.object,
  selectedLocation: PropTypes.object,
  onSelectLocation: PropTypes.func,
  places: PropTypes.array,
  onMapApiLoaded: PropTypes.func
};

MapLocation.defaultProps = {
  center: { lat: 37.775354, lng: -122.419101 },
  defaultZoom: 9,
  places: []
};

export default MapLocation;
